module.exports = __webpack_public_path__ + "img/phon3.33a4c413.png";